module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/magic-0ac30f7c3acd2206fa64c8e9862b0356.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/magic.svg
// module id = T8Wl
// module chunks = 24